// Shared PDF / Excel export helpers for reports.
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// columns: [{ header, key }], rows: [{ ... }]
export function exportPdf(filename, title, columns, rows, subtitle = "") {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.setTextColor(78, 115, 223);
  doc.text(title, 14, 18);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(133, 135, 150);
    doc.text(subtitle, 14, 25);
  }
  autoTable(doc, {
    startY: subtitle ? 30 : 24,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => (r[c.key] ?? "-").toString())),
    headStyles: { fillColor: [78, 115, 223] },
    styles: { fontSize: 9 },
  });
  doc.save(filename.endsWith(".pdf") ? filename : `${filename}.pdf`);
}

// Neutralizes formula/CSV injection (CWE-1236): if a free-text field (room
// number, description, guest name, etc.) starts with = + - @ or a tab/CR,
// Excel/Sheets can interpret it as a formula when the file is opened —
// e.g. a room number of `=HYPERLINK("http://evil","click")` could run on
// whoever opens the exported report. Prefixing with a tab/quote keeps the
// value literal without changing how it displays.
function sheetSafe(v) {
  if (typeof v !== "string") return v;
  return /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
}

export function exportExcel(filename, sheetName, columns, rows) {
  const data = rows.map((r) => {
    const o = {};
    columns.forEach((c) => { o[c.header] = sheetSafe(r[c.key] ?? ""); });
    return o;
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}
